module.exports = __webpack_public_path__ + "static/media/button_arrow_right.fee0559b.svg";